'use client';

import React, { useState, useEffect } from 'react';
import remoteConfigDiscovery from 'json/RemoteConfig.json';
import { RemoteConfig } from 'RemoteConfig';
import { isMobile as GetIsMobile } from 'utils/misc';

import * as styles from './PromotionalBanner.css';

interface PromotionalBannerProps {
  matrixSlug: string;
}

function PromotionalBanner({ matrixSlug }: PromotionalBannerProps) {
  const [bannerData, setBannerData] = useState<{
    imageUrl: string;
    alt: string;
    targetUrl: string;
  } | null>(null);

  useEffect(() => {
    const mobile = GetIsMobile();

    const bannerConfig = (remoteConfigDiscovery as RemoteConfig).discovery?.collection?.[matrixSlug]?.promotionalBanner;

    if (!bannerConfig?.status || !bannerConfig?.banners) {
      setBannerData(null);
      return;
    }

    const deviceType = mobile ? 'mobile' : 'desktop';
    const imageUrl = bannerConfig.banners[deviceType]?.imageUrl;
    const alt = bannerConfig.banners[deviceType]?.alt;
    const { targetUrl } = bannerConfig;

    if (imageUrl) {
      setBannerData({
        imageUrl,
        alt,
        targetUrl,
      });
    } else {
      setBannerData(null);
    }
  }, [matrixSlug]);

  if (!bannerData?.imageUrl) return null;

  const handleBannerClick = () => {
    if (bannerData.targetUrl) {
      window.open(bannerData.targetUrl, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <div className={styles.PromotionalBannerContainer}>
      <button
        type="button"
        className={styles.PromotionalBannerButton}
        onClick={handleBannerClick}
        aria-label={bannerData.alt}
      >
        <img
          src={bannerData.imageUrl}
          alt={bannerData.alt}
          className={styles.PromotionalBannerImage}
        />
      </button>
    </div>
  );
}

export default PromotionalBanner;
